import { Component, ViewEncapsulation } from '@angular/core';

interface ProductInfo {
  name: string; // Display name of the product
  prices: number[]; // Price bands, from 1 to 10
  link?: string;
  isBundle?: boolean;
  isDiscount?: boolean;
  daggers?: number;
}

@Component({
  templateUrl: 'subscriptions.component.html',
  styleUrls: ['subscriptions.component.scss'],
  encapsulation: ViewEncapsulation.None, // Required so we can adjust some css properties of mat tab
})
export class SubscriptionsComponent {
  readonly bands = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

  readonly productInfo: ProductInfo[] = [
    {
      name: 'Ultimate Bundle',
      prices: [15650, 14308, 12117, 11395, 9052, 8894, 5231, 4122, 3943, 3827],
      isBundle: true,
    },
    {
      name: 'Premium Bundle',
      prices: [14298, 13055, 11092, 10435, 8308, 7899, 4755, 3841, 3679, 3558],
      isBundle: true,
    },
    {
      name: 'Standard Bundle',
      prices: [11155, 10419, 8889, 8589, 6797, 6641, 3697, 2960, 2950, 2950],
      isBundle: true,
    },
    {
      name: 'OS',
      prices: [7169, 6843, 6005, 5730, 4955, 4635, 2596, 1764, 1754, 1754],
      link: '/os',
    },
    {
      name: 'Marine',
      prices: [3635, 3635, 2326, 2181, 1018, 948, 614, 550, 550, 537],
      link: '/marine',
    },
    {
      name: 'aerial-lidar-special-case',
      prices: [3160, 2655, 2211, 1859, 1517, 1265, 1061, 886, 733, 614],
    },
    {
      name: 'geology-special-case',
      prices: [1446, 1446, 859, 859, 535, 535, 282, 282, 282, 282],
      link: '/geology',
    },
    {
      name: 'Global',
      prices: [1138, 1087, 954, 912, 788, 738, 412, 281, 281, 281],
      link: '/global',
    },
    {
      name: 'Historic',
      prices: [866, 866, 803, 803, 702, 702, 392, 392, 392, 392],
      link: '/historic',
      daggers: 1,
    },
    {
      name: 'Society',
      prices: [759, 725, 637, 608, 526, 491, 275, 187, 187, 187],
      link: '/society',
      daggers: 1,
    },
    {
      name: 'Environment',
      prices: [335, 292, 266, 247, 234, 202, 189, 145, 145, 145],
      link: '/environment',
    },
    {
      name: 'Verisk',
      prices: [2348, 2243, 1969, 1880, 1627, 1523, 851, 579, 579, 579],
      link: '/verisk',
    },
    {
      name: 'agCensus',
      prices: [1244, 1244, 1036, 1036, 829, 829, 621, 621, 414, 414],
      link: '/agcensus',
    },
    {
      name: 'OS National Geographic Database (NGD)',
      prices: [4247, 4058, 3561, 3402, 2943, 2757, 1540, 1046, 1046, 1046],
      link: '/whats-new#ngd',
      daggers: 1,
    },
    {
      name: 'Discounted OS National Geographic Database (NGD) bought with Ultimate*',
      prices: [2973, 2840, 2493, 2382, 2060, 1930, 1077, 732, 732, 732],
      isDiscount: true,
      link: '/whats-new#ngd',
    },
    {
      name: 'Discounted OS National Geographic Database (NGD) bought with Premium*',
      prices: [3398, 3246, 2849, 2722, 2355, 2206, 1231, 837, 837, 837],
      isDiscount: true,
      link: '/whats-new#ngd',
    },
    {
      name: 'Discounted OS National Geographic Database (NGD) bought with Standard*',
      prices: [3823, 3651, 3205, 3062, 2649, 2481, 1385, 941, 941, 941],
      isDiscount: true,
      link: '/whats-new#ngd',
    },
    {
      name: 'National Tree Map',
      prices: [2621, 2446, 1756, 1441, 1136, 874, 612, 524, 480, 437],
      link: '/help/our-maps-and-data/national_tree_map/',
      daggers: 1,
    },
    {
      name: 'Discounted National Tree Map bought with Ultimate*',
      prices: [2097, 1957, 1404, 1153, 909, 699, 489, 419, 384, 349],
      isDiscount: true,
      link: '/help/our-maps-and-data/national_tree_map/',
    },
    {
      name: 'Discounted National Tree Map bought with Premium*',
      prices: [2228, 2079, 1493, 1225, 965, 743, 520, 446, 408, 371],
      isDiscount: true,
      link: '/help/our-maps-and-data/national_tree_map/',
    },
    {
      name: 'Discounted National Tree Map bought with Standard*',
      prices: [2359, 2201, 1580, 1297, 1022, 786, 550, 472, 432, 393],
      isDiscount: true,
      link: '/help/our-maps-and-data/national_tree_map/',
    },
    {
      name: 'Aerial Extra bought with Aerial & Lidar',
      prices: [1185, 996, 830, 697, 569, 474, 399, 332, 275, 230],
      link: '/help/our-maps-and-data/aerial_products/#aerial-extra',
      daggers: 2,
    },
    {
      name: 'Discounted Aerial Extra bought with Ultimate*',
      prices: [1037, 871, 726, 609, 498, 415, 348, 290, 240, 201],
      isDiscount: true,
      link: '/help/our-maps-and-data/aerial_products/#aerial-extra',
    },
    {
      name: 'Discounted Aerial Extra bought with Premium*',
      prices: [1111, 934, 778, 653, 533, 444, 373, 311, 258, 215],
      isDiscount: true,
      link: '/help/our-maps-and-data/aerial_products/#aerial-extra',
    },
    {
      name: 'Landclan',
      prices: [1300, 1242, 1090, 1041, 901, 843, 471, 320, 320, 320],
      link: '/whats-new#landclan',
      daggers: 1,
    },
    {
      name: 'Discounted Landclan bought with Ultimate*',
      prices: [1040, 993, 872, 833, 721, 675, 376, 256, 256, 256],
      isDiscount: true,
      link: '/whats-new#landclan',
    },
    {
      name: 'Discounted Landclan bought with Premium*',
      prices: [1106, 1056, 927, 885, 765, 718, 400, 272, 272, 272],
      isDiscount: true,
      link: '/whats-new#landclan',
    },
    {
      name: 'Discounted Landclan bought with Standard*',
      prices: [1170, 1118, 981, 937, 811, 759, 424, 288, 288, 288],
      isDiscount: true,
      link: '/whats-new#landclan',
    },
  ];

  getBundles(): ProductInfo[] {
    return this.productInfo.filter(product => product.isBundle);
  }

  getProducts(): ProductInfo[] {
    return this.productInfo.filter(product => !product.isBundle);
  }
}
